import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return JSON.stringify(it).toLowerCase().includes(searchText);
        });
    }
}
export const onlyAlphabets = /^[a-zA-Z ]*$/;
export const email_pattern = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$";
export const mobile_number_pattern = "/^-?(0|[1-9]\d*)?$/"
@Pipe({
    name: 'HTMLFormatter'
})
export class HTMLFormatter implements PipeTransform {
    transform(input, flag?) {
        let out_str = (' ' + input).slice(1);
        try {
            out_str = out_str.replace(/&nbsp;/g, ' ');
            out_str = out_str.replace(/nbsp;/g, ' ');
            out_str = out_str.replace(/&amp;/g, '');
            out_str = out_str.replace(/amp;/g, '');
            out_str = out_str.replace(/\\n/g, '<br/>');
            out_str = out_str.replace(/\\/g, '');
            if (flag) {
                out_str = out_str.replace(/\<[a-z]{1,6}\>/g, '');
                out_str = out_str.replace(/<\/[a-z]{1,6}>/g, '');
            }
        }
        catch (err) {
            out_str = input;
        }
        return out_str;
    }
}
